export default "__VITE_ASSET__BtVqUx4B__"